import MessagesFromUploader from './MessagesFromUploader.component';

export default MessagesFromUploader;